const playAdminReducer = (state = false, action) => {
  switch (action.type) {
    case 'PLAY_ADMIN':
      return action.data
    default:
      return state
  }
}

export default playAdminReducer
